// @flow
import React, { Component } from 'react';
import {
  MixpanelTrackingProvider,
  type TrackingServiceProviderInterface,
} from './Providers';
import type { TrackingEvent } from './TrackingEventTypes.constants';

export type TrackEvent = (TrackingEvent, Object) => any;

type TrackerContextType = {
  track: TrackEvent,
  providers: TrackingServiceProviderInterface[],
}

// This context will allow us to re-use this providers specific
// context in other components that register as a consumer
// See: https://reactjs.org/docs/context.html for more details
export const TrackingContext = React.createContext<TrackerContextType>({
  track: () => {},
  providers: [],
});

type Props = {
  children: any,
};

class TrackingProvider extends Component<Props> {
  // Register additional tracking providers
  providers: TrackingServiceProviderInterface[] = [
    new MixpanelTrackingProvider(),
  ];

  track = (eventName: TrackingEvent, additionalProps: Object = {}) => {
    this.providers.forEach(provider => provider.track(eventName, additionalProps));
  };

  render() {
    const {
      children,
    } = this.props;

    return (
      <TrackingContext.Provider
        value={{
          track: this.track,
          providers: this.providers,
        }}
      >
        {children || null}
      </TrackingContext.Provider>
    );
  }
}

export default TrackingProvider;
